import { supabase } from '@/lib/supabase';

/**
 * Record an activity event. The IP address is resolved server-side by the
 * `log-activity` edge function, and the acting user is derived from the
 * authenticated session. Logging is best-effort and never throws.
 */
export async function logActivity(action: string, details?: string) {
  try {
    await supabase.functions.invoke('log-activity', {
      body: { action, details: details || '' },
    });
  } catch {
    // Swallow logging errors so they never break the user-facing flow.
  }
}